// @flow
import React from 'react'
import styled from 'styled-components'
import Value from './value'

type ValueSizeReferenceProps = ValueFontConfig & {
    onChangeSize: (number, number) => void
}

const referenceTextSize = 10

export default class ValueSizeReference extends React.PureComponent<ValueSizeReferenceProps> {

    reference: React$ElementRef<any>

    constructor (props: ValueSizeReferenceProps) {
        super(props)
        this.reference = React.createRef()
    }

    componentDidMount () {
        this.componentDidRender()
    }

    componentDidUpdate () {
        this.componentDidRender()
    }

    componentDidRender = () => {
        const boundingRect = this.reference.current.getBoundingClientRect()

        this.props.onChangeSize(boundingRect.width, boundingRect.height)
    }

    render () {
        return (
            <InvisibleReferenceContainer>
                <InvisibleReference fontSize={referenceTextSize} ref={this.reference}>
                    <Value fontSize={referenceTextSize} {...this.props} />
                </InvisibleReference>
            </InvisibleReferenceContainer>
        )
    }

}

const InvisibleReferenceContainer = styled.div`
    position: absolute;
`
const InvisibleReference = styled.div`
    visibility: hidden;
`
